<template>
    <div class="all" :style="'background-color:'+jobInfo.jobExInfo.bgColor">
        <van-nav-bar
                :title="jobInfo.name"
                left-text="返回"
                left-arrow
                @click-left="$goBack()"
        />
        <div class="banner" >
            <img :src="jobInfo.jobExInfo.bannerUrl"/>
        </div>

        <div v-if="jobInfo.linkMode=='主动申请'">
            <div class="middle">
                <div class="title">{{jobInfo.name}}</div>

                <div v-if="jobInfo.jobOrderStatus==0">
                    <div class="applyExplain">
                        <ul>
                            <li>您的账号{{jobInfo.jobLinkUpPid}}已申请成功</li>
                            <li>请点击下面按钮进入对应页面填写账号获取推广码</li>
                        </ul>
                    </div>
                    <div class="applyBut">
                        <a :href="jobInfo.linkTpl">获取推广码</a>
                    </div>
                </div>
                <div v-else>
                    <div class="applyExplain" v-if="jobInfo.id == 7">
                        <ul>
                            <li>点击下方按钮填写手机号进行申请</li>
                            <li>此处填写手机号必须和下一个页面填写手机号一致，否则将无法获取拉新数据！</li>
                        </ul>
                    </div>
                    <div class="applyExplain" v-else>
                        <ul>
                            <li>点击下方按钮填写手机号进行申请</li>
                        </ul>
                    </div>
                    <div class="applyBut">
                        <div @click="applyDialog">点击申请</div>
                    </div>
                </div>

                <div class="bottom" v-if="query.biz==301">
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">充值说明</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <router-link :to="'/main/task/rule?id='+jobInfo.id">赚佣政策</router-link>
                        </van-col>
                    </van-row>
                </div>

                <div class="bottom" v-else>
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">拉新教程</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <router-link :to="'/main/task/rule?id='+jobInfo.id">拉新规则</router-link>
                        </van-col>
                    </van-row>
                </div>

            </div>
        </div>

        <div v-else>
            <div class="middle">
                <div class="title">{{jobInfo.name}}</div>
                <div class="qrCode" v-if="jobInfo.shareType!=1">
                    <img :src="jobInfo.jobQrCode" v-if="jobInfo.jobQrCode&&jobInfo.jobQrCode.indexOf('data:image')>=0"/>
                    <vue-qr :margin="0" :logoSrc="jobInfo.jobExInfo.logoUrl" :text="jobInfo.jobQrCode" :logoScale="0.25"
                            v-else-if="jobInfo.jobQrCode"
                            :size="185" :callback="qrCallback"></vue-qr>

                    <img :src="lqdefault" v-else @click="signUp"/>
                </div>

                <div class="button" v-if="jobInfo.shareType==1">



                    <van-button tag="a" :href="jobInfo.linkTpl" target="_blank" type="info" >
                        <span style="color: #fff">创建推广码</span>
                    </van-button>

                </div>

                <div class="sub_title" v-if="pageStyle !== 1">
                    <div v-if="query.id==33">请扫码获取推广码</div>
                    <div v-else-if="query.id==44">扫码抢单</div>
                    <div v-else-if="jobInfo.id==74">扫码填写资料开通</div>
                    <div v-else-if="jobInfo.id==55">推广员扫码报备</div>
                    <div v-else-if="jobInfo.id==77" style="font-size:1.5rem;font-weight:bold;">请使用手机浏览器扫码做单</div>
                    <div v-else-if="jobInfo.id==113||jobInfo.id==114">扫码开通推广权限</div>
                    <div v-else-if="jobInfo.id==120">扫码报备资料</div>
                    <div v-else>
                        <div v-if="jobInfo.shareType!=1">
                        请用顾客的手机扫码
                        </div>
                    </div>
                    <b v-if="'LINK_MODE_BY_STOCK_ACCACH_AREA'===jobInfo.linkTpl && jobInfo.linkAtrr1"><br/>类型：{{jobInfo.linkAtrr1}}</b>
                    <b v-if="'LINK_MODE_BY_STOCK_ACCACH_SHOW_ACCTOUNT'===jobInfo.linkTpl && jobInfo.linkAtrr1"><br/>用户名：{{jobInfo.linkAtrr1}}，密码{{jobInfo.linkAtrr2}}</b>
                </div>
                <div v-if="jobInfo.ruleDesc" style="margin-top: 1rem; text-align: center;">
                    {{jobInfo.ruleDesc}}
                </div>
                <div class="bottom" v-if="query.biz==301">
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">充值说明</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <router-link :to="'/main/task/rule?id='+jobInfo.id">赚佣政策</router-link>
                        </van-col>
                    </van-row>
                </div>

                <div class="bottom" v-else-if="query.id==28">
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">白条流程</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <router-link :to="'/main/task/rule?id='+jobInfo.id">银行+流程</router-link>
                        </van-col>
                    </van-row>
                </div>

                <div class="bottom" v-else-if="query.id==50">
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">拉新教程</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right" v-if="jobInfo.jobLinkUpPid">
                            <a :href="'http://tools.jingfenbang.com/pop.html?uid='+jobInfo.jobLinkUpPid">
                                转链小工具
                            </a>
                        </van-col>
                    </van-row>
                </div>

                <div class="bottom" v-else>
                    <van-row>
                        <van-col span="12">
                            <router-link :to="'/main/task/course?id='+jobInfo.id">拉新教程</router-link>
                        </van-col>
                        <van-col span="12" style="text-align:right">
                            <a v-if="jobInfo.id == 22" :href="jobInfo.linkAtrr1">
                                指定页面
                            </a>
                            <router-link v-else :to="'/main/task/rule?id='+jobInfo.id">
                                <template v-if="pageStyle === 1">
                                    商家二维码
                                </template>
                                <template v-else-if="jobInfo.id == 71">
                                    新用户识别码
                                </template>
                                <template v-else-if="jobInfo.id == 93">
                                    主播二维码
                                </template>
                                <template v-else-if="jobInfo.id == 103">
                                    次留教程
                                </template>
                                <template v-else-if="jobInfo.id == 111">
                                    锐兔下载
                                </template>
                                <template v-else-if="jobInfo.id == 113">
                                    推广工具
                                </template>
                                <template v-else-if="jobInfo.id == 114">
                                    复购二维码
                                </template>
                                <template v-else-if="jobInfo.id == 120">
                                    母链接+复购商品
                                </template>
                                <template v-else>
                                    拉新规则
                                </template>
                            </router-link>
                        </van-col>
                    </van-row>
                </div>

            </div>

            <div v-if="jobInfo.jobQrCode && jobInfo.jobExInfo.posterUrl" style="text-align: center; margin-top: 1rem;">
                <van-button round type="danger" style="width: 50%;" @click="shareDialogVisible=true">
                    分享海报
                </van-button>
            </div>

            <div v-if="jobInfo.id == 103" style="text-align: center;">
                <van-row>
                    <van-button round type="warning" style="width: 50%; margin-top: 1rem;" @click="fugouDialogVisible=true">点击获取复购海报</van-button>
                </van-row>
                <!--<van-row>-->
                    <!--<van-button round type="primary" style="width: 50%; margin-top: 1rem;" @click="declareVisible=true">点击复购报单</van-button>-->
                <!--</van-row>-->
            </div>

            <!--<div v-if="jobInfo.id == 1 && jobInfo.jobQrCode" style="text-align: center;">-->
                <!--<van-button round type="primary" style="width:50%;font-size:1.5rem" :url="'http://17youtui.mbao123.com/#/activity/jobDeclare/taobaoDeclare?jobId=1&traderId=' + jobInfo.traderId">-->
                    <!--点击购物报单-->
                <!--</van-button>-->
            <!--</div>-->

            <div class="middle" v-if="jobInfo.id == 22 && jobInfo.linkAtrr1">
                <div class="title">指定页面二维码</div>
                <div class="qrCode" style="padding: 1rem;">
                    <vue-qr :margin="0" :logoSrc="jobInfo.jobExInfo.logoUrl" :text="jobInfo.linkAtrr1"
                            :logoScale="0.25"
                            v-if="jobInfo.linkAtrr1"
                            :size="185" :callback="qrCallback"></vue-qr>
                </div>
            </div>

            <div class="button" v-if="jobInfo.jobQrCode">
                <div @click="savePhoto">长按二维码保存到相册</div>
            </div>

            <div v-if="jobInfo.jobQrCode&&(jobInfo.id==22||jobInfo.id==6||jobInfo.id==67||jobInfo.id==70)"
                 style="margin: 2rem 10%;">
                （实时数据查询，开始结束时间必填，最多只返回100条）
                <van-field
                        v-model="titleTimeStart"
                        placeholder="选择开始时间" readonly="readonly"
                        @click="dateShowStart = true"
                />
                <van-field
                        v-model="titleTime"
                        placeholder="选择结束时间" readonly="readonly"
                        @click="dateShow = true"
                />
                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table width="100%">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <div v-if="jobInfo.id==6||jobInfo.id==67">
                                    <van-cell title="订单时间" :value="row.orderDate"/>
                                    <van-cell title="京东账户" :value="row.jdAccount"/>
                                    <van-cell title="是否开通白条" :value="row.ext1 ? '是' : '否'"/>
                                    <van-cell title="白条开通时间" :value="row.ext2"/>
                                    <van-cell title="首单交易时间" :value="row.ext3"/>
                                    <van-cell title="是否购券" :value="row.ext4"/>
                                    <van-cell title="是否领取礼金" :value="'success' == row.ext5 ? '是' : '否'"/>
                                    <van-cell title="用户参与与白条首单时间差" :value="row.ext6"/>
                                </div>
                                <div v-else-if="jobInfo.id==70">
                                    <van-cell title="下单时间" :value="row.orderDate"/>
                                    <van-cell title="订单号" :value="row.orderNum"/>
                                    <van-cell title="付款金额" :value="row.price"/>
                                    <van-cell title="商品名称" :value="row.productName"/>
                                </div>
                                <div v-else>
                                    <van-cell title="下单时间" :value="row.orderDate"/>
                                    <van-cell title="订单号" :value="row.orderNum"/>
                                    <van-cell title="付款金额" :value="row.price"/>
                                    <van-cell title="是否为首购" :value="row.firstBuy == '有效' ? '有效' : '待确认'"/>
                                    <van-cell title="商品名称" :value="row.productName"/>
                                    <!--<van-cell title="是否有效下载" :value="row.validDown"/>-->
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <van-popup v-model="dateShowStart" position="bottom">
                    <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirm"/>
                </van-popup>
                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                         @confirm="handleEndDateConfirm"/>
                </van-popup>
            </div>


            <div v-if="jobInfo.jobQrCode&&(jobInfo.id==36||jobInfo.id==18)" style="margin: 2rem 10%;">
                （实时数据查询，截止以下时间段前一天数据）
                <van-field
                        v-model="titleTime"
                        placeholder="选择时间" readonly="readonly"
                        @click="dateShow = true"
                />
                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table style="width:100%;">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <van-cell title="下单时间" :value="row.createTime"/>
                                <van-cell title="激活时间" :value="row.activeTime"/>
                                <van-cell title="激活状态" :value="row.ifActive == 1 ? '已激活' : '未激活'"/>
                                <van-cell title="物流单号" :value="row.logisticsCompanyCode"/>
                                <van-cell title="发货状态" :value="row.status == 1 ? '已发货' : '未发货'"/>
                                <van-cell title="认证状态" :value="row.mMsg"/>
                                <van-cell title="联系电话" :value="row.phone"/>
                                <van-cell title="开卡人姓名" :value="row.accountName"/>
                                <div style="text-align:center">
                                    <van-button round size="small" @click="openDialog(row)">查看更多</van-button>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>

                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                         @confirm="handleEndDateConfirm2"/>
                </van-popup>
            </div>

            <div v-if="jobInfo.jobQrCode&&jobInfo.id==73" style="margin: 2rem 10%;">
                （实时数据查询，开始结束时间必填，最多只返回100条）
                <van-field
                        v-model="titleTimeStart"
                        placeholder="选择开始时间" readonly="readonly"
                        @click="dateShowStart = true"
                />
                <van-field
                        v-model="titleTime"
                        placeholder="选择结束时间" readonly="readonly"
                        @click="dateShow = true"
                />
                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table width="100%">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <div>
                                    <van-cell title="下单时间" :value="row.orderDate"/>
                                    <van-cell title="订单号" :value="row.orderNum"/>
                                    <van-cell title="订单状态" :value="row.ext1"/>
                                    <van-cell title="是否首单" :value="row.ext2"/>
                                    <van-cell title="销售类型" :value="row.ext3"/>
                                    <van-cell title="订单类型" :value="row.ext4"/>
                                    <van-cell title="商品id" :value="row.ext5"/>
                                    <van-cell title="商品名称" :value="row.ext6"/>
                                    <van-cell title="支付金额" :value="row.ext7"/>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <van-popup v-model="dateShowStart" position="bottom">
                    <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirm3"/>
                </van-popup>
                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                         @confirm="handleEndDateConfirm3"/>
                </van-popup>
            </div>

            <div v-if="jobInfo.jobQrCode&&(jobInfo.id==76||jobInfo.id==78)" style="margin: 2rem 10%;">
                （实时数据查询，开始结束时间必填，最多只返回100条）
                <van-field
                        v-model="titleTimeStart"
                        placeholder="选择开始时间" readonly="readonly"
                        @click="dateShowStart = true"
                />
                <van-field
                        v-model="titleTime"
                        placeholder="选择结束时间" readonly="readonly"
                        @click="dateShow = true"
                />
                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table width="100%">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <div>
                                    <van-cell title="订单时间" :value="row.gmtCreate|parseTime('{y}-{m}-{d} {h}:{i}:{s}')"/>
                                    <van-cell title="订单号" :value="row.orderId"/>
                                    <van-cell title="充值账户" :value="row.uid"/>
                                    <van-cell title="订单状态" :value="jdPayStatusMap[row.status]"/>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <van-popup v-model="dateShowStart" position="bottom">
                    <van-datetime-picker v-model="currentDateStart" type="datetime" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirm4"/>
                </van-popup>
                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="datetime" @cancel="handleCancel"
                                         @confirm="handleEndDateConfirm4"/>
                </van-popup>
            </div>


            <div v-if="jobInfo.jobQrCode&&(jobInfo.id==124)" style="margin: 2rem 10%;">
                （实时数据查询）
                <van-field
                        v-model="titleTimeStart"
                        placeholder="选择开始时间" readonly="readonly"
                        @click="dateShowStart = true"
                />

                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table width="100%">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <div>
                                    <van-cell  :value="row.orderid"/>
                                    <van-cell title="订单时间" :value="row.paytime|parseTime('{y}-{m}-{d} {h}:{i}:{s}')"/>

                                    <van-cell title="标题" :value="row.smstitle"/>
                                    <van-cell title="订单状态" :value="mtPayStatusMap[row.status]"/>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <van-popup v-model="dateShowStart" position="bottom">
                    <van-datetime-picker v-model="currentDateStart" type="date" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirm5"/>
                </van-popup>
                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" @cancel="handleCancel"
                                         @confirm="handleEndDateConfirm5"/>
                </van-popup>
            </div>

            <div v-if="jobInfo.jobQrCode&&(jobInfo.id==161)" style="margin: 2rem 10%;">
                （实时数据查询）
                <van-field
                        v-model="titleTimeStart"
                        placeholder="选择开始时间" readonly="readonly"
                        @click="dateShowStart = true"
                />

                <div class="table-box" v-if="runtimeData.page&&runtimeData.page.length>0">
                    <table width="100%">
                        <tr v-for="(row,index) in runtimeData.page" :key="row.id">
                            <td style="text-align:left;word-break:break-all;">
                                <div>
                                    <van-cell  :value="row.orderid"/>
                                    <van-cell title="订单时间" :value="row.orderTime|parseTime('{y}-{m}-{d} {h}:{i}:{s}')"/>

                                    <van-cell title="姓名" :value="row.name"/>
                                    <van-cell title="订单状态" :value="row.status"/>
                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                <van-popup v-model="dateShowStart" position="bottom">
                    <van-datetime-picker v-model="currentDateStart" type="date" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirmCmccOrder"/>
                </van-popup>
                <van-popup v-model="dateShow" position="bottom">
                    <van-datetime-picker v-model="currentDate" type="date" @cancel="handleCancel"
                                         @confirm="handleStartDateConfirmCmccOrder"/>
                </van-popup>
            </div>

          <div v-if="jobInfo.jobQrCode&&(jobInfo.id==205||jobInfo.id==188||jobInfo.id==198||jobInfo.id==219||jobInfo.id==255||jobInfo.id==256)">

            <van-row>
              <van-button round style="width:90%;margin:1rem;" @click="goDetail('/main/task/saasCommonDetail?jobId='+jobInfo.id+'&linkId=' + jobInfo.traderId)">
              查询数据
              </van-button>
            </van-row>
          </div>

        </div>



        <div class="middlek"  v-if="jobInfo.shareType==1">
            <div  v-html="jobInfo.taskIntro"></div>
        </div>
        <div class="middlek"  v-if="jobInfo.shareType==1">
            <!------------------------>


            <div v-if="jobInfo.jobExInfo.videoUrl" style="margin-bottom: 2rem">
                <!--<p>视频教程</p>-->
                <video-player ref="videoPlayer" :playsinline="true" :options="playerOptions" style="margin-bottom: 1rem;"></video-player>

            </div>
            <div v-if="jobInfo.jobExInfo.courseUrl" style="margin-bottom: 2rem">
                <!--<p>图片教程</p>-->
                <img :src="jobInfo.jobExInfo.courseUrl" width="100%"/>
            </div>
            <!------------------------>
        </div>



        <van-dialog title="更多详情" v-model="dialogVisible" style="height: 85%; overflow-y: scroll;">
            <table style="width:100%;">
                <td style="text-align:left;word-break:break-all;">
                    <van-cell title="订单号" :value="dialogData.orderNumber"/>
                    <van-cell title="收货人姓名" :value="dialogData.receiver"/>
                    <van-cell title="身份证号" :value="dialogData.idCard"/>
                    <van-cell title="地址" :value="dialogData.address"/>
                    <van-cell title="所选号码" :value="dialogData.choosePhone"/>
                    <van-cell title="二级商户名称" :value="dialogData.ename"/>
                    <van-cell title="物流公司" :value="dialogData.logisticsCompany"/>
                    <van-cell title="发货时间" :value="dialogData.deliverTime"/>
                    <van-cell title="下单时间" :value="dialogData.createTime"/>
                </td>
            </table>
        </van-dialog>


        <van-dialog
                v-model="apply.show"
                title="申请任务"
                show-cancel-button
                @confirm="applyConfirm">
            <van-field v-model="apply.account" placeholder="输入申请手机号" clearable/>
        </van-dialog>

        <div class="share">
            <van-popup v-model="share.show" position="bottom" :overlay="share.overlay">
                <van-row>请选择分享平台</van-row>
                <van-row>
                    <van-col span="6">
                        <img :src="share.weixin">
                        <p>微信</p>
                    </van-col>
                    <van-col span="6">
                        <img :src="share.wxfriend">
                        <p>微信朋友圈</p>
                    </van-col>
                    <van-col span="7">
                        <img :src="share.qq">
                        <p>QQ</p>
                    </van-col>
                    <van-col span="5">
                        <img :src="share.QQZone">
                        <p>QQ空间</p>
                    </van-col>
                </van-row>
            </van-popup>
        </div>
        <van-popup
                v-model="jdAreaShow"
                position="bottom">
            <van-area :area-list="jdAreaList" :columns-num="1" title="当前可领取类型" @cancel="jdAreaCancel"
                      @confirm="jdAreaConfirm"/>
        </van-popup>

        <van-dialog
                v-model="stbaGuide.show"
                title="未备案，该任务需先备案，请扫描二维码或者复制链接到淘宝完成备案"
                confirmButtonText="复制链接"
                cancelButtonText="已备案"
                :before-close="stbaAction"
                closeOnClickOverlay
                show-cancel-button>
            <vue-qr :margin="30" :text="stbaGuide.url" :size="300"></vue-qr>
        </van-dialog>

        <van-dialog
                v-model="declareVisible"
                title="次日复购报单"
                show-cancel-button
                @confirm="declareOrder()"
                @cancel="closeDeclareDialog()">
            <van-cell-group style="margin-top: 1rem;">
                <!--<van-field v-model="declareForm.phone" label="手机号" placeholder="请输入手机号"/>-->
                <van-field v-model="declareForm.orderId" label="订单号" placeholder="请输入复购订单号"/>
            </van-cell-group>

            <!--<table style="width: 100%">-->
                <!--<tr>-->
                    <!--<td width="30%" style="text-align:center;">-->
                        <!--<span>上传图片1</span>-->
                    <!--</td>-->
                    <!--<td width="30%">-->
                        <!--<div class="uploader_box">-->
                            <!--<img :src="exampleImg1" @click="previewExampleImg1"/>-->
                        <!--</div>-->
                    <!--</td>-->
                    <!--<td width="30%">-->
                        <!--<div class="uploader_box">-->
                            <!--<input type="file" id="logimg1" accept="image/*" @change="onRead(1)"/>-->
                            <!--<img v-if="declareForm.proofImg1" :src="declareForm.proofImg1"/>-->
                            <!--<img v-else :src="camera"/>-->
                        <!--</div>-->
                    <!--</td>-->
                <!--</tr>-->
                <!--<tr>-->
                    <!--<td width="30%" style="text-align:center;">-->
                        <!--<span>上传图片2</span>-->
                    <!--</td>-->
                    <!--<td width="30%">-->
                        <!--<div class="uploader_box">-->
                            <!--<img :src="exampleImg2" @click="previewExampleImg2"/>-->
                        <!--</div>-->
                    <!--</td>-->
                    <!--<td width="30%">-->
                        <!--<div class="uploader_box">-->
                            <!--<input type="file" id="logimg2" accept="image/*" @change="onRead(2)"/>-->
                            <!--<img v-if="declareForm.proofImg2" :src="declareForm.proofImg2"/>-->
                            <!--<img v-else :src="camera"/>-->
                        <!--</div>-->
                    <!--</td>-->
                <!--</tr>-->
            <!--</table>-->
        </van-dialog>

        <van-dialog v-model="shareDialog" title="复制文案分享到微信" confirm-button-text="关闭">
            <div style="margin:10%;">
                <p>[色]京东爆款福利抢先得[太阳]</p>
                <p>1.开通白条即刻领取25元满减券<br/>
                    {{jobInfo.jobQrCode}}</p>
                <p>2.新用户购物低至0.1元[胜利]<br/>
                    {{jobInfo.linkAtrr1}}</p>
                <p>3.下载京东金融APP还白条，还可得8元话费充值券<br/>
                    {{jobInfo.linkAtrr2}}</p>
                <p>超香福利[红包] 爱了快来抢<br/>
                    机会如此好，分享好友不可少[耶]</p>
            </div>

            <div style="text-align:center;margin-bottom:1rem;">
                <van-button round type="primary" size="normal" v-clipboard:copy="shareText"
                            v-clipboard:success="onCopy"
                            v-clipboard:error="onError">点击复制分享文案
                </van-button>
            </div>
        </van-dialog>

        <van-dialog v-model="shareDialogVisible" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <img :src="shareImgSrc" width="100%"/>
            <vue-canvas-poster v-if="jobInfo.jobQrCode && jobInfo.jobExInfo.posterUrl" :widthPixels="565" :painting="painting"
                               @success="success" @fail="fail">
            </vue-canvas-poster>
        </van-dialog>

        <van-dialog
                v-model="signVisible"
                title="代收代付协议签署"
                show-cancel-button
                confirm-button-text="同意并前往申请"
                @confirm="signContract()">
            <van-tabs>
                <van-tab title="企业">
                    <van-cell-group>
                        <van-field v-model="signForm.companyName" label="公司名" placeholder="请输入姓名或公司名称"/>
                        <van-field v-model="signForm.unifiedCreditCode" label="统一信用代码" placeholder="请输入统一信用代码"/>
                        <van-field v-model="signForm.phone" label="手机号" placeholder="请输入法人手机号码"/>
                    </van-cell-group>
                </van-tab>
                <van-tab title="个人">
                    <van-cell-group>
                        <van-field v-model="signForm.companyName" label="姓名" placeholder="请输入姓名"/>
                        <van-field v-model="signForm.unifiedCreditCode" label="身份证" placeholder="请输入身份证号码"/>
                        <van-field v-model="signForm.phone" label="手机号" placeholder="请输入手机号码"/>
                    </van-cell-group>
                </van-tab>
            </van-tabs>
        </van-dialog>

        <van-dialog v-model="fugouDialogVisible" confirm-button-text="长按图片保存至本地" close-on-click-overlay>
            <img src="http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWC1zxA.png" width="100%"/>
            <van-row style="text-align:center;">
                特价版复购二维码
            </van-row>
            <van-row style="text-align:center;">
                请使用淘宝特价版扫码
            </van-row>
        </van-dialog>
    </div>
</template>

<script>
    import weixin from '@/assets/images/weixin1.png'
    import wxfriend from '@/assets/images/wxfriend.png'
    import qq from '@/assets/images/qq1.png'
    import QQZone from '@/assets/images/QQZone1.png'
    import lqdefault from '@/assets/images/lqdefault.jpg'
    import QRCode from 'qrcodejs2'
    import vueQr from 'vue-qr'
    import mainAPI from '@/api/main'
    import countAPI from '@/api/count'
    import {ImagePreview} from "vant";

    export default {
        components: {
            vueQr
        },
        data() {
            return {
                share: {
                    weixin: weixin,
                    wxfriend: wxfriend,
                    qq: qq,
                    QQZone: QQZone,
                    show: false,
                    overlay: ''
                },
                lqdefault: lqdefault,
                jobInfo: {
                    id: null,
                    name: null,
                    linkTpl: '',
                    linkMode: '',
                    jobQrCode: null,
                    jobLink: '',
                    traderId: '',
                    jobExInfo: {
                        bannerUrl: '',
                        logoUrl: '',
                        ruleUrl: '',
                        courseUrl: '',
                        bgColor: '',
                        videoUrl: ''
                    },
                    linkAtrr1: '',
                    linkAtrr2: ''
                },
                query: {
                    id: this.$route.query.id,
                    biz: this.$route.query.biz
                },
                apply: {
                    show: false,
                    account: ''
                },
                jdAreaShow: false,
                jdAreaList: {
                    province_list: {}
                },
                stbaGuide: {
                    show: false,
                    url: ''
                },
                pageStyle: '',
                dateShow: false,
                currentDate: new Date(),
                titleTime: "",
                dateShowStart: false,
                titleTimeStart: "",
                currentDateStart: new Date(),
                runtimeData: {},
                dialogVisible: false,
                dialogData: {},
                declareVisible: false,
                declareForm: {
                    jobId: null,
                    phone: '',
                    orderId: '',
                    proofImg1: '',
                    proofImg2: '',
                },
                camera: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMQ23p.png',
                exampleImg1: 'http://jho2o2.oss-cn-beijing.aliyuncs.com/test/2NWMOZd3.png',
                exampleImg2: '',
                shareDialog: false,
                shareText: '',
                shareDialogVisible: false,
                shareImgSrc: '',
                painting: {
                    width: '565px',
                    height: '800px',
                    background: '#f4f5f7',
                    views: []
                },
                signVisible: false,
                signForm: {
                    companyName: null,
                    unifiedCreditCode: null,
                    phone: null,
                },
                jdPayStatusMap: {"0": "待付款", "1": "已付款(已用券)", "2": "已付款发货失败", "3": "已还款", "4": "已付款(未用券)"},
                mtPayStatusMap: { "1": "已付款", "8": "已完成", "9": "已退款或风控"},

                fugouDialogVisible: false,

                playerOptions : {
                    playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                    autoplay: false, //如果true,浏览器准备好时开始回放。
                    muted: false, // 默认情况下将会消除任何音频。
                    loop: false, // 导致视频一结束就重新开始。
                    preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                    language: 'zh-CN',
                    aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                    fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                    sources: [{
                        src: '',  // 路径
                        type: 'video/mp4'  // 类型
                    }],
                    poster: "", //你的封面地址
                    // width: document.documentElement.clientWidth,
                    notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                    controlBar: {
                        timeDivider: true,
                        durationDisplay: true,
                        remainingTimeDisplay: false,
                        fullscreenToggle: true  //全屏按钮
                    }
                }
            }
        },
        created() {
            this.taskInfo()
        },
        methods: {
          goDetail(url){
            console.log(url)
            this.$router.push(url)
          },
            getTempUrl(){
                return jobInfo.linkTpl;
            },
            taskInfo() {
                this.$toast.loading({forbidClick: true})
                mainAPI.taskInfo(this.query.id, this.query.biz, null).then((result) => {
                    let jobInfo = result.data;
                    if (jobInfo.bizId == '302' && jobInfo.jobLink != null) {
                        window.location.href = jobInfo.jobLink;
                        return
                    }
                    let base64ImgData = jobInfo.jobExInfo.base64LogoData;
                    if (base64ImgData) {
                        let blob = this.base64ImgDataToBlob(base64ImgData);
                        jobInfo.jobExInfo.logoUrl = this.getObjectURL(blob);
                    }
                    //videoUrl
                    this.playerOptions.sources[0].src = jobInfo.jobExInfo.videoUrl;
                    console.log(jobInfo.jobExInfo.posterUrl);
                    console.log(jobInfo.jobExInfo.posterUrl);
                    this.painting.background=jobInfo.jobExInfo.posterUrl;

                    this.jobInfo = jobInfo;
                    this.choosePageStyle();
                    this.$toast.clear();
                    if (this.jobInfo.recycleStatus == 1) {
                        this.$toast('由于长时间未做单，您的部分任务单已被回收')
                    }
                    this.shareText = '[色]京东爆款福利抢先得[太阳]\n' +
                        '1.开通白条即刻领取25元满减券\n' +
                        (this.jobInfo.jobQrCode ? this.jobInfo.jobQrCode : '') + '\n\n' +
                        '2.新用户购物低至0.1元[胜利]\n' +
                        (this.jobInfo.linkAtrr1 ? this.jobInfo.linkAtrr1 : '') + '\n\n' +
                        '3.下载京东金融APP还白条，还可得8元话费充值券\n' +
                        (this.jobInfo.linkAtrr2 ? this.jobInfo.linkAtrr2 : '') + '\n\n' +
                        '超香福利[红包] 爱了快来抢\n' +
                        '机会如此好，分享好友不可少[耶]';

                    if (this.jobInfo.jobQrCode && this.jobInfo.jobExInfo.posterUrl) {
                        this.jobInfo.jobExInfo.posterUrl = this.jobInfo.jobExInfo.posterUrl.replace("jho2o.oss-cn-beijing.aliyuncs.com", "17youtuiimg.mbao123.com");
                        this.addPoster();
                    }


                    console.log('bbbbbbbbbbbbbbbbb');
                    console.log(jobInfo.id)
                    console.log('ccccccccccccccccccccccc');
                }).catch(() => {
                    this.$toast('任务未上架或不存在')
                    this.$goBack()
                })
            },
            choosePageStyle() {
                if (this.jobInfo.bizId === 118) {
                    // 隐藏副标题，拉新规则 改为 商家二维码
                    this.pageStyle = 1
                }
            },
            signUp() {
                if (this.jobInfo.id) {
                    // if (55 == this.jobInfo.id) {
                    //     this.signVisible = true;
                    //     return;
                    // }

                    this.$toast.loading({forbidClick: true})
                    if ("LINK_MODE_BY_STOCK_ACCACH_AREA" === this.jobInfo.linkTpl && !this.jobInfo.linkAtrr1) { // 京东任务且未选择省份
                        mainAPI.getJdProvince(this.jobInfo.bizId).then((result) => {
                            this.jdAreaList.province_list = result.data
                            this.jdAreaShow = true
                            this.$toast.clear()
                        })
                        return
                    }
                    mainAPI.signUp(this.jobInfo.id, this.apply.account, this.jobInfo.linkAtrr1, this.jobInfo.linkAtrr2).then((result) => {
                        if (result.mng === 'stlx_beian') {
                            // 手淘拉新未备案弹出备案引导
                            this.stbaGuide.url = result.data
                            this.stbaGuide.show = true
                            return
                        }
                        this.$toast.success('领取成功')
                        this.$toast.clear()
                        this.taskInfo()
                    })
                }
            },
            applyDialog() {
                this.apply.show = true
            },
            applyConfirm() {
                if (!this.apply.account) {
                    this.$toast('请填写申请账号')
                    return
                }
                // if (!this.$myUtil.mobile(this.apply.account)) {
                //     this.$toast('请填写正确的手机号账号')
                //     return
                // }
                this.signUp()
            },
            applyCancel() {
            },
            qrCallback(url, id) {
            },
            savePhoto() {
            },
            base64ImgDataToBlob(base64ImgData) {
                var arr = base64ImgData.split(','),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new Blob([u8arr], {type: mime});
            },
            getObjectURL(file) {
                var url = null;
                if (window.createObjectURL !== undefined) { // basic
                    url = window.createObjectURL(file);
                } else if (window.URL !== undefined) { // mozilla(firefox)
                    url = window.URL.createObjectURL(file);
                } else if (window.webkitURL !== undefined) { // webkit or chrome
                    url = window.webkitURL.createObjectURL(file);
                }
                return url;
            },
            jdAreaCancel() {
                this.jdAreaShow = false
            },
            jdAreaConfirm(e) {
                this.jobInfo.linkAtrr1 = e[0].name
                this.jdAreaShow = false
                this.signUp()
                this.jobInfo.linkAtrr1 = ''
            },
            handleCancel() {
                this.dateShow = false;
                this.dateShowStart = false;
            },
            //开始时间
            handleStartDateConfirm() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryJdcpaDetail();
            },
            //结束时间
            handleEndDateConfirm() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryJdcpaDetail();
            },
            handleEndDateConfirm2() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySaasDetail();
            },
            handleStartDateConfirm3() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.querySuNingDetail();
            },
            handleEndDateConfirm3() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.querySuNingDetail();
            },
            handleStartDateConfirm4() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat(this.currentDateStart);
                this.queryJdpayOrderDetail();
            },
            handleEndDateConfirm4() {
                this.dateShow = false;
                this.titleTime = this.timeFormat(this.currentDate);
                this.queryJdpayOrderDetail();
            },
            handleStartDateConfirm5() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat5(this.currentDateStart);
                this.queryMeituanDetail();
            },
            handleEndDateConfirm5() {
                this.dateShow = false;
                this.titleTime = this.timeFormat5(this.currentDate);
                this.queryMeituanDetail();
            },

            handleStartDateConfirmCmccOrder() {
                this.dateShowStart = false;
                this.titleTimeStart = this.timeFormat5(this.currentDateStart);
                this.queryCmccOrderDetail();
            },
            timeFormat(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + " " + hour + ":" + minute + ":" + second;
            }
            ,
            timeFormat5(datetime) { // 时间格式化 2019-09-08
                var year = datetime.getFullYear();
                var month = (datetime.getMonth() + 1) < 10 ? "0" + (datetime.getMonth() + 1) : (datetime.getMonth() + 1);
                var date = datetime.getDate() < 10 ? "0" + datetime.getDate() : datetime.getDate();
                var hour = datetime.getHours() < 10 ? "0" + datetime.getHours() : datetime.getHours();
                var minute = datetime.getMinutes() < 10 ? "0" + datetime.getMinutes() : datetime.getMinutes();
                var second = datetime.getSeconds() < 10 ? "0" + datetime.getSeconds() : datetime.getSeconds();
                return year + "-" + month + "-" + date + "" ;
            }
            ,
            queryJdcpaDetail() {
                //if(!isNaN(this.month4selected)){
                //  this.queryLog.startSettleDate=this.$myUtil.startDateDef(this.month4selected*30)
                //}

                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});

                    let queryObj = {};
                    queryObj.ext1 = this.titleTime;
                    // queryObj.ext2 = this.jobInfo.linkAtrr1;
                    queryObj.ext2 = this.jobInfo.jobLinkUpPid;
                    queryObj.ext3 = this.titleTimeStart;
                    if (this.jobInfo.id == 6 || this.jobInfo.id == 67) {
                        queryObj.ext4 = 2;
                    }

                    countAPI.jdCpaDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },

            querySaasDetail() {
                this.$toast.loading({forbidClick: true});
                let queryObj = {};

                queryObj.ext1 = this.titleTime;
                queryObj.ext2 = this.jobInfo.linkAtrr1;
                queryObj.jobId = this.jobInfo.id;

                countAPI.saasDetail(queryObj).then((result) => {
                    this.runtimeData = result.data;
                    this.$toast.clear()
                })
            },

            querySuNingDetail() {
                let queryObj = {};
                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});
                    queryObj.ext1 = this.titleTimeStart;
                    queryObj.ext2 = this.titleTime;
                    queryObj.ext3 = this.jobInfo.jobLinkUpPid;

                    countAPI.suningDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
            queryJdpayOrderDetail() {
                let queryObj = {};
                if (this.titleTime && this.titleTimeStart) {
                    this.$toast.loading({forbidClick: true});
                    queryObj.ext1 = this.titleTimeStart;
                    queryObj.ext2 = this.titleTime;
                    queryObj.ext3 = this.jobInfo.jobLinkUpPid;

                    countAPI.jdpayOrderDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },

            queryMeituanDetail() {
                if (this.titleTimeStart ) {
                    this.$toast.loading({forbidClick: true});
                    let queryObj = {};
                    //queryObj.ext1 = this.titleTime;
                    // queryObj.ext2 = this.jobInfo.linkAtrr1;
                    queryObj.ext2 = this.jobInfo.jobLinkUpPid;
                    //queryObj.ext2 = 'mb1361';
                    queryObj.ext3 = this.titleTimeStart;
                    countAPI.meituanDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
            queryCmccOrderDetail() {
                if (this.titleTimeStart ) {
                    this.$toast.loading({forbidClick: true});
                    let queryObj = {};
                    queryObj.ext2 = this.jobInfo.jobLinkUpPid;
                    //queryObj.ext2 = 'mb1361';
                    queryObj.ext3 = this.titleTimeStart;
                    countAPI.cmccOrderDetail(queryObj).then((result) => {
                        this.runtimeData = result.data;
                        this.$toast.clear()
                    })
                }
            },
            openDialog(row) {
                this.dialogVisible = true;
                this.dialogData = row;
            },

            stbaAction(action, done) {
                if (action === 'confirm') {
                    const _this = this
                    this.$copyText(this.stbaGuide.url).then(function () {
                        _this.$toast({
                            type: 'success',
                            message: '复制成功'
                        })
                    }, function () {
                        _this.$toast({
                            type: 'warning',
                            message: '复制失败'
                        })
                    })
                    done(false)
                } else if (action === 'cancel') {
                    this.signUp()
                    done()
                } else {
                    done()
                }
            },

            onRead(type) { // 上传图片到图片服务器
                let file = document.getElementById('logimg' + type).files[0];

                let self = this;
                let reader = new FileReader();
                reader.onload = e => {
                    let result = e.target.result;
                    let formData = new FormData();
                    formData.append("dirName", "任务报单上传目录");

                    if (result.length / 1024 > 500) {
                        let img = new Image();
                        img.src = result;
                        img.onload = function () {
                            self.$toast("开始压缩图片...");
                            //0.6为压缩的程度，数值越小，压缩的文件越小，图片也会越模糊
                            let src = self.$myUtil.compressImg(img, 0.6);
                            formData.append("file", self.$myUtil.base64ImgDataToFile(src, file.name));
                            self.uploadImg(formData, type);
                        }
                    } else {
                        formData.append("file", file);
                        self.uploadImg(formData, type);
                    }
                };
                // 读取图像
                reader.readAsDataURL(file);
            },
            //上传图片
            uploadImg(formData, type) {
                this.$toast("开始上传图片...");
                this.$http.post('/sys/ossFileMapping/upload', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }).then(res => {
                    if (1 === type) {
                        this.declareForm.proofImg1 = res.data; //这里上传到指定的图片服务器，成功后会返回图片的url
                    } else if (2 === type) {
                        this.declareForm.proofImg2 = res.data;
                    }
                    this.$toast("图片上传成功");
                }).catch(() => {
                    this.$toast("图片上传失败");
                })
            },
            previewExampleImg1() {
                ImagePreview([
                    this.exampleImg1,
                ]);
            },
            previewExampleImg2() {
                ImagePreview([
                    this.exampleImg2,
                ]);
            },
            declareOrder() {
                if (!this.declareForm.orderId) {
                    this.$toast("请先填写订单号");
                    return;
                }
                // if (!this.declareForm.phone) {
                //     this.$toast("请先填写手机号");
                //     return;
                // }
                // if (!this.declareForm.proofImg1) {
                //     this.$toast("请先上传凭证");
                //     return;
                // }
                // if (!this.declareForm.proofImg2) {
                //     this.$toast("请先上传凭证");
                //     return;
                // }
                this.declareForm.jobId = this.jobInfo.id;
                mainAPI.jobOrderDeclare(this.declareForm).then(() => {
                    this.closeDeclareDialog();
                    this.$toast("报单成功");
                }).catch(() => {
                });
            },
            closeDeclareDialog() {
                this.declareForm.phone = '';
                this.declareForm.orderId = '';
                this.declareForm.proofImg1 = '';
                this.declareVisible = false;
            },
            openShareDialog() {
                this.shareDialog = true;
            },
            onError() {
                this.$toast.fail('复制失败')
            },
            onCopy() {
                this.$toast.success('分享文案已经复制到剪切板')
            },
            success(src) {
                this.shareImgSrc = src;
            },
            fail(err) {
                console.log('fail', err)
            },
            addPoster() {
                this.painting.views.push(
                    {
                        type: 'image',
                        url: this.jobInfo.jobExInfo.posterUrl,
                        css: {}
                    }
                );
                this.painting.views.push(
                    {
                        type: 'rect',
                        css: {
                            top: '610px',
                            left: '400px',
                            color: '#fff',
                            width: '110px',
                            height: '110px'
                        }
                    }
                );

                if(this.jobInfo.jobQrCode.indexOf("http")>=0){
                    this.painting.views.push({
                        type: 'qrcode',
                        content: this.jobInfo.jobQrCode,
                        css: {
                            top: '612px',
                            left: '402px',
                            color: '#000',
                            width: '106px',
                            height: '106px'
                        }
                    });
                }
                if(this.jobInfo.jobQrCode.indexOf("data:image")>=0){
                    this.painting.views.push({
                         type: 'image',
                        url: this.jobInfo.jobQrCode,
                        css: {
                            top: '612px',
                            left: '402px',
                            color: '#000',
                            width: '106px',
                            height: '106px'
                        }
                    });
                }

            },
            signContract() {
                if (!this.signForm.companyName || !this.signForm.unifiedCreditCode || !this.signForm.phone) {
                    this.$toast("请先填写信息");
                    return;
                }
                this.$toast("协议签署中...");
                mainAPI.signContract(this.signForm.companyName, this.signForm.unifiedCreditCode, this.signForm.phone).then(() => {
                    window.location.href = "http://mengbao123.mikecrm.com/JNXNcnk";
                }).catch(() => {
                });
            }
        }
    }
</script>

<style lang="scss" scoped>

    .video-js .vjs-big-play-button {
        left: 50% !important;
        top: 50% !important;
        margin-left: -1.5em;
        margin-top: -1em;
    }
    .banner {
        width: 100%;
        height: auto;

    img {
        width: 100%;
        height: 100%;
    }

    background-size: 100% auto;
    overflow: hidden;
    }

    .middlek {
        background-color: #fff;
        margin: 1rem 2%;
        border-radius: 1rem;
        padding: 1rem;
    }

    .middle {
        background-color: #fff;
        margin: 1rem 8%;
        border-radius: 1rem;
        padding: 1rem;

        .title {
            font-size: 1.6rem;
            font-weight: bold;
            text-align: center;
        }

        .sub_title {
            font-size: 1rem;
            text-align: center;
            padding: 1rem 0 0 0;
            color: #888;
        }

        .qrCode {
            margin: 1rem auto 0 auto;
            width: 15.42rem;
            height: 15.42rem;
            background: white;

            img {
                width: 100%;
                height: 100%;
            }
        }

        .bottom {
            margin: 1rem 8% 0 8%;

            a {
                color: blue;
                text-decoration: underline;
            }
        }
        .showJdOrder {
            text-align: center;
            border-top: 1px solid #f2f2f2;
            border-left: 1px solid #f2f2f2;
            border-right: 1px solid #f2f2f2;
            color: #7d7e80;
            .rowOrder {
                height: 19rem;
                .head {
                    color: #000;
                }
            }
            .table-box {
                height: 19rem;
                width: 100%;
                overflow-x: scroll;
                white-space: nowrap;
                -webkit-overflow-scrolling: touch;
                table tr td {
                    text-align: center;
                    line-height: 1.6rem;
                }
            }
        }

        // .bottom{
        //   margin: 1rem 10% 0 10%;
        //   display: flex;
        //   justify-content:space-around;
        //   .left {
        //     display: flex;
        //     justify-content:flex-start;
        //   }
        //   .right {
        //     display: flex;
        //     justify-content:flex-end;
        //   }
        // }

        .applyExplain {
            margin: 1rem 5% 1rem 15%;
            font-size: 1rem;
            color: #888;
            line-height: 2rem;
        }

        .applyBut {
            background-color: #f2f2f2;
            margin: 2rem 10%;
            height: 3rem;
            border-radius: 2rem;
            text-align: center;
            line-height: 3rem;
            color: blue;
        }

    }

    .button {
        background-color: #fff;
        margin: 2rem 10%;
        height: 3rem;
        border-radius: 2rem;
        text-align: center;
        line-height: 3rem;
    }

    .share {
        .van-popup {
            background-color: #f2f2f2;
            text-align: center;
            font-size: 1.2rem;

        }

        .van-row {
            margin: 2rem 3rem;

            .van-col {
                font-size: 1rem;
            }
        }

        img {
            height: 3rem;
            width: 3rem;
        }
    }

    .uploader_box {
        width: 7rem;
        height: 11rem;
        overflow: hidden;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }
    }

    #logimg1, #logimg2 {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    #shareBtn {
        color: blue;
        background-color: transparent;
        border: 0px none; //去边框
        font-size: 15px;
        text-decoration: underline; //加下划线
    }

</style>
